var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5773 12.2431C22.5773 11.3387 22.5039 10.6788 22.3451 9.99448H12.0186V14.0762H18.08C17.9578 15.0905 17.2979 16.6181 15.8314 17.6446L15.8108 17.7812L19.0759 20.3106L19.3021 20.3332C21.3796 18.4145 22.5773 15.5915 22.5773 12.2431Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0186 22.9973C14.9882 22.9973 17.4812 22.0196 19.3022 20.3332L15.8315 17.6446C14.9027 18.2923 13.6562 18.7445 12.0186 18.7445C9.1101 18.7445 6.64153 16.8259 5.76155 14.174L5.63257 14.1849L2.23751 16.8124L2.19312 16.9358C4.00177 20.5287 7.71688 22.9973 12.0186 22.9973Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76162 14.174C5.52943 13.4896 5.39506 12.7563 5.39506 11.9987C5.39506 11.2409 5.52943 10.5077 5.74941 9.82337L5.74326 9.67762L2.30566 7.00794L2.19318 7.06144C1.44775 8.55239 1.02002 10.2267 1.02002 11.9987C1.02002 13.7707 1.44775 15.4449 2.19318 16.9358L5.76162 14.174Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0186 5.25279C14.0839 5.25279 15.477 6.1449 16.2714 6.89042L19.3755 3.85965C17.4691 2.08765 14.9882 1 12.0186 1C7.71688 1 4.00177 3.46857 2.19312 7.06144L5.74934 9.82337C6.64153 7.17147 9.1101 5.25279 12.0186 5.25279Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1718489b7774fb6924b56838264885db.svg";
export { ForwardRef as ReactComponent };